import { GREY_CHATEAU, HOVER_LIGHT_BLUE } from "../../../constants/colors";

const borderColor = GREY_CHATEAU;
const hoverBackgroundColor = HOVER_LIGHT_BLUE;

export const fallbackValues = {
  borderColor,
  hoverBackgroundColor
};
